export const LINK_WHATS_BELL =
  'https://api.whatsapp.com/send?phone=5511995752096&text=Ol%C3%A1%20Bel'
export const LABEL = 'Negociar pelo Whatsapp'
